import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { QuestionnaireAnswers } from "@/Modules/Models/Domain/Questionnaire";
import type { QuestionnaireAnswersApi } from "@/Modules/Models/Api/Questionnaire";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import camelize from "@/Utils/Camelize";

const QuestionnaireAnswersTransformer: TransformerExtended<QuestionnaireAnswers, QuestionnaireAnswersApi> = {
  ...DefaultTransformerGenerator<QuestionnaireAnswers, QuestionnaireAnswersApi>(),

  toDomain(value: QuestionnaireAnswersApi): QuestionnaireAnswers {
    return camelize<QuestionnaireAnswersApi, QuestionnaireAnswers>(value) as QuestionnaireAnswers;
  },
};

export type QuestionnaireAnswersTransformerType = TransformerExtended<
  QuestionnaireAnswers,
  QuestionnaireAnswersApi
>;

export default QuestionnaireAnswersTransformer;
